export default __webpack_public_path__ + "static/media/setting.9dd51c2f.svg";